var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('MainPage',{attrs:{"data":_vm.content[_vm.locality],"locality":_vm.locality}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }